module.exports = __webpack_public_path__ + "static/media/unlabeledaddress.a8598e43.svg";